import React, { useState, useEffect } from "react";
import {client, socket, socketConnected} from "../../../utils/nakama";
import eventsCenter, { PHASER_EVENTS } from "../../../utils/phaserEvents";
import Overlay from 'react-bootstrap/Overlay';

export default function LobbyList(props) {
const [onlineUsers, setOnlineUsers] = useState([]);

useEffect(() => {
    // Only set the socket handler if socket is available
    if (socket) {
        socket.onchannelpresence = async (presences) => {
            // console.log("LobbyList socket presences: ", presences);
            setOnlineUsers(presences);
        };
    }
}, [socket]);

useEffect(() => {
    // console.log("LobbyList mounted props:", props);
    // console.log("LobbyList showing: ", props.showing);
    if(!props.showing) {
        return;
    }
    // console.log("LobbyList is showing!!");
    //query the lobby
    // setupInternalPhaserEventListeners();
    const getLobby = async () => {
        const res = await socket.joinChat("lobby", 1, true, false);
        // console.log("LobbyList Join lobby: ", res);
        setOnlineUsers(res.presences);

    }
    getLobby();
    return () => {
        // console.log("LobbyList unmounting");
        eventsCenter.removeListener(PHASER_EVENTS.LOBBY_UPDATE);
    }
}, [props.showing]);


    return (
        <div style={{display: "inline-block", verticalAlign : "top"}}>
            <h1 style={{color : "#FFFFFF", fontFamily: "Truculenta,sans-serif", fontWeight: "bold", fontSize: "4rem"}}>Lobby List</h1>
            {( onlineUsers && onlineUsers.length > 0) ? (
            <ul>
                {
                onlineUsers.map((user) => {
                    return <li key={user.user_id} class ="lobby-list-names">
                        {user.username} </li>
                })}
            </ul>
            ) : (
                <p style={{color : "#FFFFFF"}}>No one is online</p>
            )}
        </div>
    )
}